import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import * as Sentry from '@sentry/react';
import i18n from '../../i18n';
import { ROUTES } from '../../router/routes';
export class PageErrorBoundary extends Component {
    state = { hasError: false };
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error, info) {
        Sentry.captureException(error, {
            level: 'warning',
            tags: { boundary: 'page', path: window.location.pathname },
            contexts: { react: { componentStack: info.componentStack ?? '' } },
        });
    }
    render() {
        if (this.state.hasError) {
            return (_jsxs("div", { className: "flex min-h-[60vh] flex-col items-center justify-center p-8 text-center", children: [_jsx("p", { className: "text-lg font-semibold text-gray-800", children: i18n.t('common:pageError.title') }), _jsx("p", { className: "mt-1 text-sm text-gray-500", children: i18n.t('common:pageError.subtitle') }), _jsx("a", { href: ROUTES.HOME, className: "mt-4 rounded-lg bg-primary px-5 py-2 text-sm font-medium text-white", children: i18n.t('common:pageError.goHome') })] }));
        }
        return this.props.children;
    }
}
//# sourceMappingURL=PageErrorBoundary.js.map